import React from "react";
import NoContentWarning from "components/NoContentWarning";

const NoStudyModesWarning = () => (
  <NoContentWarning warning="No study modes available at this time." />
);

export default NoStudyModesWarning;
